import requests from '../../requests'

export default {
  list (filter) {
    const rawFilter = new URLSearchParams(filter).toString()
    return requests.get(`warehouse/hires?${rawFilter}`)
  }
}
